import { Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  display: flex;
  gap: 40px;
  line-height: ${props => props.theme.old.fonts.size.small};

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    position: absolute;
    left:0;
    bottom: -24px;
    width: 100vw;
    min-width: 240px;
    justify-content: center;
  }
`

export const NavLink = styled(Link)`
  color: ${({ theme, $isActive }) => $isActive ? theme.old.colors.white : theme.old.colors.gray[500]};
  font-size: ${props => props.theme.old.fonts.size.normal};
  font-weight: ${props => props.theme.old.fonts.weight.semibold};
  font-family: ${props => props.theme.old.fonts.family.primary};
  cursor: pointer;
  transition: ${props => props.theme.old.transition.default};
  position: relative;
  letter-spacing: .12em;

  :hover {
    color: ${({ theme, $isActive }) => $isActive ? theme.old.colors.white : theme.old.colors.gray[650]};
  }
`

export const NavLinkUnderline = styled.div`
  position: absolute;
  width: 24px;
  height: 3px;
  background-color: ${({ theme }) => theme.old.colors.white};
  border-radius: 10px;
  transition: all 300ms, opacity 100ms;
  top: 55px;
  left: ${({ offset }) => `${offset}px`};

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    top: unset;
    bottom: -10px;
  }
`